import React from 'react';

interface Prompt {
  id: string;
  content: string;
  categoryName?: string;
  author?: string;
  isPublic?: boolean;
  isHidden?: boolean;
}

interface Props {
  prompts: Prompt[];

  handleHidePrompt: (
    promptId: string
  ) => Promise<void>;

  handleRestorePrompt: (
    promptId: string
  ) => Promise<void>;

  handleDeletePrompt: (
    promptId: string
  ) => Promise<void>;
  hasMore: boolean;
  onLoadMore: () => Promise<void>;
  loadingMore: boolean;
}

const PromptsSection: React.FC<Props> = ({
  prompts,
  handleHidePrompt,
  handleRestorePrompt,
  handleDeletePrompt,
  hasMore,
  onLoadMore,
  loadingMore,
}) => {

  return (

    <>

      <div className="mb-10">

        <h1 className="text-4xl font-bold">

          Prompts

        </h1>

        <p className="text-slate-400 mt-2">

          Gerenciamento de prompts da Nexora.

        </p>

      </div>

      {/* tabela vem aqui */}

<div className="bg-slate-900 border border-slate-800 rounded-2xl overflow-hidden">

      <div className="p-6 border-b border-slate-800">

        <h2 className="text-xl font-semibold">
          Prompts Recentes
        </h2>

      </div>

      <table className="w-full">

        <thead className="bg-slate-950">

          <tr>

            <th className="text-left p-4 text-slate-400">
              Prompt
            </th>

            <th className="text-left p-4 text-slate-400">
              Categoria
            </th>

            <th className="text-left p-4 text-slate-400">
              Autor
            </th>

            <th className="text-left p-4 text-slate-400">
              Status
            </th>

            <th className="text-left p-4 text-slate-400">

              Ações

           </th>

        

          </tr>

        </thead>

        <tbody>

          {prompts.length === 0 && (
            <tr>
              <td colSpan={5} className="p-8 text-center text-slate-400">Nenhum prompt encontrado.</td>
            </tr>
          )}

          {prompts.map((prompt) => (

  <tr
    key={prompt.id}
    className="border-t border-slate-800"
  >

    <td className="p-4 max-w-[350px] truncate">

      {prompt.content}

    </td>

    <td className="p-4">

      {prompt.categoryName}

    </td>

    <td className="p-4">

      {prompt.author || 'Desconhecido'}

    </td>

    <td className="p-4">

      <span
  className={`px-3 py-1 rounded-full text-sm ${
    prompt.isHidden
      ? 'bg-red-500/20 text-red-400'
      : prompt.isPublic
      ? 'bg-green-500/20 text-green-400'
      : 'bg-yellow-500/20 text-yellow-400'
  }`}
>

  {prompt.isHidden
    ? 'Oculto'
    : prompt.isPublic
    ? 'Público'
    : 'Privado'}

</span>
    </td>
<td className="p-4">

  <div className="flex gap-2">

    {prompt.isHidden ? (

  <button

    onClick={() =>
      handleRestorePrompt(
        prompt.id
      )
    }

    className="px-3 py-1 rounded-lg border border-green-500/20 text-green-400 hover:bg-green-500/10 transition-all text-sm"
  >

    Restaurar

  </button>

) : (

  <button

    onClick={() =>
      handleHidePrompt(
        prompt.id
      )
    }

    className="px-3 py-1 rounded-lg border border-yellow-500/20 text-yellow-400 hover:bg-yellow-500/10 transition-all text-sm"
  >

    Ocultar

  </button>

)}
    <button

      onClick={() =>
        handleDeletePrompt(
          prompt.id
        )
      }

      className="px-3 py-1 rounded-lg border border-red-500/20 text-red-400 hover:bg-red-500/10 transition-all text-sm"
    >

      Excluir

    </button>

  </div>

</td>
  </tr>

))}

        </tbody>

      </table>

    </div>

    {hasMore && (
      <div className="mt-6 flex justify-center">
        <button type="button" onClick={() => void onLoadMore()} disabled={loadingMore} className="px-4 py-2 rounded-lg bg-slate-800 text-slate-100 hover:bg-slate-700 disabled:opacity-50">
          {loadingMore ? 'Carregando...' : 'Carregar mais'}
        </button>
      </div>
    )}

    </>

  );
};

export default PromptsSection;
